import { GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'

export { RemoteworktownPage as default } from '@/components/pages/Remoteworktown'

export const getStaticProps: GetStaticProps = async () => {
  const client = new NewtClient()

  const topics = await client.fetchRemoteWorktownNews()
  return {
    props: {
      topics,
    },
  }
}

